module.exports = __webpack_public_path__ + "img/danielle-id.5807a916.png";